"use client";

import { Body, Button, Heading } from "@scott/ui-d2c";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";

interface ThankYouProps {
  isDoubleOptin: boolean;
  translation: string;
}

export const ThankYou = ({
  isDoubleOptin = false,
  translation,
}: ThankYouProps) => {
  const router = useRouter();
  const t = useTranslations(translation);

  return (
    <div className="container flex max-w-2xl items-center justify-center pt-8 pb-48">
      <div className="flex flex-col space-y-4">
        <Heading hasUnderline={true} variant={"h2"}>
          {t("thankyouPage.title")}
        </Heading>
        <Body>
          {isDoubleOptin
            ? t("thankyouPage.doubleOptin.description")
                .split("\n")
                .map((line, index) => {
                  const KEY_PREVIEW_LENGTH = 20;
                  return (
                    <span
                      className={index > 0 ? "mt-2 block" : ""}
                      key={`line-${index}-${line.substring(0, KEY_PREVIEW_LENGTH)}`}
                    >
                      {line}
                      <br />
                    </span>
                  );
                })
            : t("thankyouPage.description")}
        </Body>
        {translation === "newsletterPage" && (
          <div className="pt-4">
            <Button
              onClick={() => router.push("/")}
              size={"md"}
              variant={"solid"}
            >
              {t("thankyouPage.submitButton.label")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
